import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_retdeuda, p_transoli, p_prcmanual, p_ejecutivo, p_fecpago, p_finiqsinsol) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_retdeuda": p_retdeuda,
					"p_transoli": p_transoli,
					"p_prcmanual": p_prcmanual,
					"p_ejecutivo": p_ejecutivo,
					"p_fecpago": p_fecpago,
					"p_finiqsinsol": p_finiqsinsol
				  })
			})
	},

	finiquitos(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.recuperar_finiquito",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	valtransferir(p_email, p_usuario, p_registro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.valtransferir",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_registro": p_registro
				  })
			})
	},

	transferir(p_email, p_usuario, p_registro, p_tipo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.transferir",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_registro": p_registro,
					"p_tipo": p_tipo
				  })
			})
	},

	fechatransferencia(p_email, p_usuario, p_fecha, p_registro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.fechatransferencia",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha,
					"p_registro": p_registro
				  })
			})
	},

	guardar_observacion(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.guardar_observacion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago,
					"p_observacion": p_observacion
				  })
			})
	},
	mail_finiquito(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.fnc_mail_finiquito",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago
				  })
			})
	},
	guardar_link_contishare(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago, p_link, p_nombredoc) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.guardar_link_contishare",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago,
					"p_link": p_link,
					"p_nombredoc": p_nombredoc,
				  })
			})
	},

	anular(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago, p_mail_anu) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_gartransf.fnc_anular",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago,
					"p_mail_anu": p_mail_anu,
				  })
			})
},

}